import { VictoryLabel, VictoryLabelProps } from 'victory';

export const BottomTickLabel: React.FC<VictoryLabelProps & { chartHeight: number }> = (props) => {
  return <VictoryLabel {...props} dy={props.chartHeight - (props?.y ?? 0) - 10} />;
};
